import React from 'react';
import './BlindDisplay.css';
import { useTheme } from '../../contexts/ThemeContext';

const BlindDisplay = ({ small, big }) => {
    const { darkMode } = useTheme();
    const themeClass = darkMode ? 'dark-theme' : 'light-theme';

    return (
        <div className={`blinds-display ${themeClass}`}>
            <span className="small-blind">{small}</span>
            <span className="separator">/</span>
            <span className="big-blind">{big}</span>
        </div>
    );
};

export default BlindDisplay;